import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=no, obj=yes
  useEffect(() => {
    const token = localStorage.getItem("ts_admin_token");
    if (!token) { setAdmin(false); return; }
    api.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => { localStorage.removeItem("ts_admin_token"); setAdmin(false); });
  }, []);
  const login = (token, adminData) => { localStorage.setItem("ts_admin_token", token); setAdmin(adminData); };
  const logout = () => { localStorage.removeItem("ts_admin_token"); setAdmin(false); };
  return <AdminContext.Provider value={{ admin, login, logout }}>{children}</AdminContext.Provider>;
}

export const useAdmin = () => useContext(AdminContext);
